<template>
  <router-view />

</template>

<script>
export default {
  name: 'App'
  // components: {
  //   HelloWorld
  // }
}
</script>

<style>
@import "@/style/fonts/stylesheet.css";

@import "@/style/css/all.min.css";
@import "@/style/css/bootstrap.min.css";
@import "@/style/css/glide.core.min";
@import "@/style/css/scalize.min.css";
@import "@/style/css/style.css";
/* @import "@/style/css/style-1.css";
@import "@/style/css/style-2.css"; */

/* stylesheet */

.el-carousel__arrow {
  border-radius: 0 !important;
  border: 1px solid #fff !important;
  background-color: transparent !important;
}

.parallax-background .el-carousel__arrow {
  border: none !important;
}
.parallax-background button.el-carousel__arrow {
  outline: none;
}

.el-carousel__button {
  width: 15px !important;
  height: 15px !important;
  border: 1px solid #fff !important;
  background-color: transparent !important;
}
</style>
